import { APILayerConsts } from 'vue-infra';
import BaseClass from './BaseClass';

class BaseClient extends BaseClass {
  constructor(options) {
    super({ name: options.name, type: 'Client' });
    this.client = options.client;
  }

  async sendRequest(settings) {
    const method = settings.method;
    return this.client[method](settings.url, settings.body || settings.config, settings.config);
  }
}

BaseClient.HTTP_METHODS = APILayerConsts.CRUDMethods;

export default BaseClient;
